import {RouteConfig} from 'vue-router';
import localizationFactory from "@/router/modules/localization-factory";

export default Array<RouteConfig>(
	{
		path: "",
		name: "HowRegister",
		meta: {
			layout: "authorization",
			authRequired: false
		},
		component: () => import('@/feature/Auth/views/HowRegister.vue')
	},
	// {
	// 	name: "HowRegisterPlans",
	// 	path: "howRegisterPlans",
	// 	meta: localizationFactory('howRegister.tariffs.title', {
	// 		layout: "authorization",
	// 		authRequired: false
	// 	}),
	// 	component: () => import('@/feature/Auth/views/HowRegisterPlans.vue')
	// },
	{
		name: "HowRegisterDocs",
		path: "howRegisterDocs",
		meta: localizationFactory('howRegister.doc.title', {
			layout: "authorization",
			authRequired: false
		}),
		component: () => import('@/feature/Auth/views/HowRegisterDocs.vue')
	}
);